export default "__VITE_ASSET__BV0jvnLQ__"